import { MapPin } from "lucide-react";
import { useSignup } from "@/context/SignupContext";
import { SIGNUP_ENABLED, CTA_LABEL } from "@/lib/config";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_voyage-squad-3/artifacts/242nersf_final%20llogo.png";

export default function NavBar() {
  const { openSignup } = useSignup();
  return (
    <header
      data-testid="navbar"
      className="sticky top-0 z-40 w-full backdrop-blur-md bg-[#FDFBF7]/85 border-b border-[#E5E0D8]/60"
    >
      <div className="max-w-md mx-auto md:max-w-6xl px-5 md:px-8 h-24 md:h-28 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center">
          <img
            src={LOGO_URL}
            alt="Fourdays"
            className="h-20 md:h-24 w-auto object-contain"
          />
        </a>
        <button
          onClick={SIGNUP_ENABLED ? openSignup : undefined}
          disabled={!SIGNUP_ENABLED}
          data-testid="nav-cta"
          className="rounded-full bg-[#1A1A1A] hover:bg-black disabled:hover:bg-[#1A1A1A] text-white text-sm font-semibold px-4 py-2 transition active:scale-95 disabled:cursor-default disabled:opacity-90"
        >
          {CTA_LABEL}
        </button>
      </div>

      <div
        data-testid="locations-strip"
        className="bg-[#FFEDE6] border-t border-[#FF5A36]/10"
      >
        <div className="max-w-md mx-auto md:max-w-6xl px-5 md:px-8 h-9 flex items-center justify-center md:justify-start gap-2 text-[11px] md:text-xs font-semibold text-[#7a4a00]">
          <MapPin className="h-3 w-3 text-[#FF5A36]" />
          <span className="uppercase tracking-widest text-center md:text-left">
            <span className="text-[#1A1A1A]">Live in Canggu</span>
          </span>
        </div>
      </div>
    </header>
  );
}
